import { createRoot, } from "react-dom/client";
import { App, } from "./App";

const rootEl = globalThis.document?.getElementById("root");

if(rootEl) {
	const root = createRoot(rootEl);
	root.render(<App />);
} else {
	throw new Error("Failed finding application root element");
}
